/**
 * @author: lv.chen
 * @date: 2025/12/31
 * @desc: RankChange Rank变化率
 */
import React from 'react';
import classnames from 'classnames';
import { getDodClassName } from '@intelligence/v3/pages/CasualDailyReports/utils';

interface IRankChangeProps extends IBaseProps {
  data?: string;
}

const RankChange: React.FC<IRankChangeProps> = (props) => {
  const { style, className, data } = props;
  const numData = Number.parseInt(data as string, 10);
  const isNumDataValid = !Number.isNaN(numData);

  if (!data) return null;
  return (
    <div
      style={style}
      className={classnames(
        'dbi-rank-trend-num dbi-casual-game-reports-rank-change',
        className,
        getDodClassName(numData),
      )}
    >
      {data !== '0' && <span>{isNumDataValid ? Math.abs(numData) : data}</span>}
    </div>
  );
};

export default RankChange;
